import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalOpts } from '@shared/intro-modal/intro-modal.service';
import { ReplaySubject } from 'rxjs';
import { UsersFacade } from '@state/users';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-data-listing-request-modal',
  templateUrl: './data-listing-request-modal.component.html',
  styleUrls: ['./data-listing-request-modal.component.scss'],
  standalone: false,
})
export class DataListingRequestModalComponent implements OnInit, OnDestroy {
  public readonly data = inject<ModalOpts>(MAT_DIALOG_DATA);
  public readonly dialogRef = inject<MatDialogRef<DataListingRequestModalComponent>>(MatDialogRef);
  private readonly usersFacade = inject(UsersFacade);

  private destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  public userEmail: string;
  public step: 'INFO' | 'SENDING' | 'REQUEST_SENT' | 'ERROR' = 'INFO';

  ngOnInit(): void {
    this.usersFacade.requestDataListingSuccess$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.step = 'REQUEST_SENT';
    });

    this.usersFacade.requestDataListingError$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.step = 'ERROR';
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public close(): void {
    this.dialogRef.close();
  }

  public confirm(): void {
    this.usersFacade.requestDataListing();
    this.step = 'SENDING';
  }
}
